<template>
  <div style="text-align: center;">
    <p style="margin-top: 15px;">You must enter a city before a street name, county, or zip code.</p>
    <button type="button" @click="closeModal" class="btn btn-fill btn-info">
      OK
    </button>
  </div>
</template>

<script>
  export default {
    props: ['data'],
    methods: {
      closeModal () {
        this.$emit('close')
      }
    }
  }
</script>

<style scoped>

</style>
